export enum EnumDateFastFilterType {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    CURRENT_WEEK = 'CURRENT_WEEK',
    CURRENT_MONTH = 'CURRENT_MONTH',
    LAST_30_DAYS = 'LAST_30_DAYS',
    CUSTOM_RANGE = 'CUSTOM_RANGE',
}

export const initialDateFilters = [
    {
        type: EnumDateFastFilterType.LAST_30_DAYS,
        isActive: true
    },
    {
        type: EnumDateFastFilterType.TODAY,
        isActive: false
    },
    {
        type: EnumDateFastFilterType.YESTERDAY,
        isActive: false
    },
    {
        type: EnumDateFastFilterType.CURRENT_WEEK,
        isActive: false
    },
    {
        type: EnumDateFastFilterType.CURRENT_MONTH,
        isActive: false
    },
    {
        type: EnumDateFastFilterType.CUSTOM_RANGE,
        isActive: false
    }
];
